import React from "react";
import { useState } from "react";
import { useEffect,useRef } from "react";
import { toast } from "react-toastify";
import Spinner from "../../../common/Spinner/Spinner";
import { getUser } from "../../../utils/localStorage";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "../../../common/Pagination/Pagination";
import { getServiceTypesMaster } from "../../../utils/localStorage";
import find from "lodash/find";
import moment from "moment";
import { Button } from "../../../common/Button/Button";
import Checkbox from "../../../common/Checkbox/Checkbox";
import copysvg from "./../../../assets/arrow_copy.svg";
import ColumnSelectionDropdown from "./ColumnSelectionDropdown";
import arrow_right from "../../../assets/ic_header_arrow_right.svg";
import arrow_left from "../../../assets/ic_header_arrow_left.svg";
import arrow_more from "../../../assets/ic_more.svg";
import ColumnSectionDropdown from "./ColumnSelectionDropdown";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function AdminResourceAssignmentGrid(props)
{

	const [columnPage,setcolumnPage] =useState(0);
	const [selectedColumnsCount,setSelectedColumnCount] =useState(0);

    const copyToClipboard = (content) => {
		const el = document.createElement('textarea');
		el.value = content;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

    const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.sServiceName;
		}
		return "";
	};

	const generateColumns=()=>{

		let selectedColumnCount =0;
		let currentCount =0;
		let colPage=columnPage;

        const columns = [
					{
						id: "checkbox",
						accessor: "",
						Cell: ({ original }) => {
							return (								
								<label className="checkbox-container">
									<input type="checkbox" 
										onChange={() => {
											const updated = props.selectedServiceRequests.addOrUpdate(original,"nResourceInstanceId");
											props.onSelectServiceRequest(updated);
										}}
										checked={
											find(props.selectedServiceRequests,{nResourceInstanceId:original.nResourceInstanceId,}) !== undefined
										}
									/>
									<span className="table-checkbox"></span>
								</label>
						);
							
						},
						Header: x => {
							return (
									<label className="checkbox-container">
										<input type="checkbox"
											checked={props.selectedServiceRequests.length === parseInt(props.pageSize)}
											onChange={() => {
											const updated = props.selectedServiceRequests.toggleAll(
												x.data,
												"_original"
											);
											props.onSelectServiceRequest(updated);
											}}
										/>
										<span className="table-checkbox"></span>
									</label>
								
							);
						},
						sortable: false,
						width: 50
					},  
		];

		props.ColumnDropdownList.map((x) => {
            if (x.checked) 
			{
				selectedColumnCount++;
            }
        });

		if(selectedColumnsCount!=selectedColumnCount)
		{
			setSelectedColumnCount(selectedColumnCount);
		}

		

		if(columnPage!==0&&selectedColumnCount<=5)
		{
			colPage=0;
			setcolumnPage(0);
		}

		props.ColumnDropdownList.map((x) => {
            if (x.checked) 
			{
				currentCount++;
				if(x.code==="resourcename")
				{
					columns.push(
						{
							id: "sResourceDisplayName",
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							Header:<>
							{
								currentCount==selectedColumnCount?
								(
									<div>resourcename
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Resource + Instance ID"
								)
							}
							</>,
							width:250,
							accessor: "sResourceDisplayName",
							style: { 'whiteSpace': 'unset'},
							Cell:({original})=>(
								<>
									<span>
									{original.sResourceDisplayName}
									</span><br></br><br></br>
									<span>
										{`ID:${original.nResourceInstanceId}`}
									</span>

									<br></br><br></br>

									 
									<a href={original.sResourcePDFLink} target="_blank">
                                    <span className="label-link">PDF Link</span>
                                    </a>
									 
								</>
							)							
						},
					)
				}
				else if(x.code==="OfferingDetails")
				{
					columns.push(
						
						{
							id: "sOfferingName",
							//Header: "Package Details",
							Header:<>
							{
								currentCount==selectedColumnCount?
								(
									<div>Offering Detail
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Offering Detail"
								)
							}
							</>,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "sOfferingName",
							style: { 'whiteSpace': 'unset'},
							width:200,
							Cell:({original})=>(				
								<>
									{
										original.sOfferingName || original.sOfferingName?
										(
											<>
												<span>
													{
														original.sOfferingName ? 
														original.sOfferingName :
														""
													}
												</span><br></br><br></br>
												<span>
													{`ID:${
														original.sOfferingID ? 
														original.sOfferingID :
														""
													}`}
												</span>
											</>
										)
										:("")
									}					
								</>
							)
						},
					)
				}
				else if(x.code==="CustomerDetails")
				{
					columns.push(						
						{
							id: "sEmailId",
							//Header: "Customer Detail",
							Header:<>
							{
								currentCount==selectedColumnCount?
								(
									<div>Customer Detail
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Customer Detail"
								)
							}
							</>,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "sEmailId",
							style: { 'whiteSpace': 'unset'},
							width:330,
							Cell: ({ original }) => (
								<>
									<div className={"conv-float-left"}>
										<div>
											<span className="conv-float-left conv-mr18">Email:</span>
											{
												original.sEmailId?
												(
													<>
														<img
															alt="copy"
															src={copysvg}
															height={"20px"}
															width={"16px"}
															className="con-cursor-pointer conv-mr13 conv-ml10"
															onClick={(e) => {
																e.preventDefault();
																copyToClipboard(original.sEmailId);
																toast(`${
																	original.sFirstName ? 
																	original.sFirstName :
																	""
																}${' '}
																${
																	original.sLastName ? 
																	original.sLastName :
																	""
																}'s Email Copied!`, {
																	autoClose: 5000,
																	type: toast.TYPE.SUCCESS,
																});
															}}
														/>
														<span style={{wordBreak:"break-all",float:"right",width:"200px"}}>
															
															{
																original.sEmailId
															}
														</span><br></br>
													</>
												)
												:
												("NA")
											}
										</div>
										<div style={{"clear":"both"}}></div>
										<div className="conv-mt10">
										<span className="conv-float-left conv-mr5">Contact:</span>
											{
												original.sContactNumber?
												(
													<>
														<img
															alt="copy"
															src={copysvg}
															height={"20px"}
															width={"16px"}
															className="con-cursor-pointer conv-mr13 conv-ml10"
															onClick={(e) => {
																e.preventDefault();
																copyToClipboard(original.sContactNumber);
																toast(`${
																	original.sFirstName ? 
																	original.sFirstName :
																	""
																}${' '}
																${
																	original.sLastName ? 
																	original.sLastName :
																	""
																}'s Contact Copied!`, {
																	autoClose: 5000,
																	type: toast.TYPE.SUCCESS,
																});
															}}
														/>
														<span style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{
																original.sContactNumber
															}
														</span>
													</>
												)
												:
												("")
											}
										</div>
									</div>			
								</>
							),
						},
					)
				}
				else if(x.code==="Facilitator")
				{
					columns.push(
						{
							id: "sFacilitatorEmail",
							//Header: "Facilitator",
							Header:<>
							{
								currentCount==5||currentCount==selectedColumnCount?
								(
									<div>Facilitator
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																let count =colPage==0?1:0
																setcolumnPage(count);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Facilitator"
								)
							}
							</>,
							show:(currentCount<=5&&colPage==0)?true:false,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "sFacilitatorEmail",
							style: { 'whiteSpace': 'unset' },
							//width:200,
							Cell: ({ original }) => (
								<>
									<span style={{wordBreak:"break-all"}}>
									{original.sFacilitatorEmail?
									original.sFacilitatorEmail:
									""}
								</span>
								</>
								
								
							),
						},
					)
				}
				else if(x.code==="Handholder")
				{
					columns.push(
						{
							id: "sIHHEmail",
							//Header: "Service Partner",
							Header:<>
							{
								currentCount==5||currentCount==selectedColumnCount?
								(
									<div>Handholder
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Handholder"
								)
							}
							</>,
							show:(currentCount<=5&&colPage==0)?true:false,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "sIHHEmail",
							style: { 'whiteSpace': 'unset' },
							//width:200,
							Cell: ({ original }) => (
								original.sIHHEmail? (
                                    <span>
                                        {original.sIHHEmail?
										original.sIHHEmail:
										""}
                                    </span>
                                ) : (
                                    <span>{""}</span>
                                )
							),
						},
					)
				}
				 

				else if(x.code==="createdon")
				{
					columns.push(
						{
							id: "dtRequested",
							Header: "Created On",
							Header:<>
							{
								currentCount==5||currentCount==selectedColumnCount?
								(
									<div>
										<span style={{'width':'100px'}}>Created On</span>
										<div className="conv-float-right" style={{'width':'25px'}}>
											<img
													alt=""
													style={{'color':'white'}}
													src={arrow_more}
													height={"20px"}
													width={"20px"}
													className=""
													onClick={()=>{
														props.toggleColumnVisibility();
													}}
												/>
												{
													selectedColumnCount>5?
													(
														<img
															alt=""
															src={colPage==0?arrow_right:arrow_left}
															height={"20px"}
															width={"20px"}
															className=""
															onClick={()=>{
																setcolumnPage(colPage==0?1:0);
															}}
														/>

													):
													("")
												}											
										</div>
									</div>
								):
								(
									"Created On"
								)
							}
							</>,
							show:(currentCount<=5&&colPage==0)||(currentCount>5&&selectedColumnCount>5&&colPage==1)?true:false,
							headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
							accessor: "dtRequested",
							style: { 'whiteSpace': 'unset' },
							//width:350,
							Cell: ({ original }) =>
							original.dtRequested?(moment(original.dtRequested).format("DD/MM/YYYY"))
                            :original.dtRequested?(moment(original.dtRequested).format("DD/MM/YYYY"))
                            :("NA"),
						},
					)
				}

            }
        });

		 

        return columns;
	} 



    return (
		<div className="col-12 conv-mt25 conv-pl40 conv-pr40 spled-container fix-filter">
			<div className="spled-container">
				<div className={`service-partner spled-container`}>
					{
						props.isColumnDropdownOpen &&
						<div ref={props.ColumnDropdownRef}>
							<ColumnSectionDropdown
								isOpen={props.isColumnDropdownOpen}
								toggleSelection={props.toggleColumnSelection}
								checkboxItemsList={props.ColumnDropdownList}
								
							/>
						</div>
					}
					{
						<ReactTableFixedColumns
							minRows={0}
							data={props.data || []}
							columns={generateColumns()}
							manual
							defaultPage={props.page}
							pages={props.pages}
							page={props.page}
							pageSize={props.pageSize}
							sortable={false}
							defaultPageSize={10}
							showPagination={true}
							pageSizeOptions={[10,20,30,50,75,100]}
							onFetchData={(state, instance) => {
								props.onFetchServiceRequests(instance, false);
							}}
							onPageSizeChange={props.onPageSizeOptionChange}
							PaginationComponent={Pagination}
							style={{overflowY: "initial",height: "445px"}}			
							className="-striped hide-scrollbar"
                		/>
					}
				</div>
			</div>
		</div>        
	);
}